import { useRef, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import escapeRegExp from 'lodash/escapeRegExp';
import classnames from 'classnames';
import { SubSubNavBarProps } from '../types';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import WidgetHeaderMobile from '../../UserWidgets/_partials/WidgetHeaderMobile';
import CommissionCreateButton from '../../Sections/ShopSection/_partials/CommissionCreateButton';

import s from '../SubSubNavBar.scss';

function SubSubNavBarMobileInner(props: SubSubNavBarProps & { history: any }) {
  const dropdownRef = useRef<HTMLSelectElement>(null);
  const { location, items, className, iconClassName, rootClassName, history } =
    props;

  const navigateToSubsection = useCallback(() => {
    const newPath = dropdownRef.current?.value;
    if (newPath) {
      history.push(newPath);
    }
  }, [history]);

  const activePath = `${location.pathname || items[0].path}/`
    .replace(/\/{2,}/g, '/')
    .toLowerCase();
  const activePathReg = new RegExp(
    `${escapeRegExp(activePath)}?`.replace(/\//g, '\\/'),
    'i'
  );
  const activeItem =
    items.find(item =>
      Array.isArray(item.path)
        ? item.path.includes(activePath)
        : activePathReg.test(item.path)
    ) || {
      label: '',
      count: '',
      path: '' as string,
    };
  const activeItemPath = Array.isArray(activeItem.path)
    ? activeItem.path[0]
    : activeItem.path;

  return (
    <WidgetHeaderMobile
      className={className}
      rootClassName={rootClassName}
      header={activeItem.label}
      count={activeItem.count}
      isSticky
      extras={
        <>
          <span className={classnames(s['open-menu-button'], iconClassName)}>
            <ArrowDownIcon />
          </span>
          <select
            className={s['dropdown']}
            ref={dropdownRef}
            value={activeItemPath}
            onChange={navigateToSubsection}
          >
            {items.map((item, index) => (
              <option
                key={index}
                value={Array.isArray(item.path) ? item.path[0] : item.path}
              >
                {`${item.label} (${item.count})`}
              </option>
            ))}
          </select>
          {activeItem.label === 'Commissions' && (
            <CommissionCreateButton
              className={s['commission-create-button']}
            />
          )}
        </>
      }
    />
  );
}

export default withRouter(SubSubNavBarMobileInner);
